import React from 'react';
import SEO from '../components/common/SEO';
import Layout from '../components/layout/Layout';
import NewHero from '../components/home/NewHero';
import Audience from '../components/home/Audience';
import HowItWorksNew from '../components/home/HowItWorksNew';
import WhyChoose from '../components/home/WhyChoose';
import LatestPosts from '../components/home/LatestPosts';
import NewFAQ from '../components/home/NewFAQ';
import CTA from '../components/home/CTA';
import { siteConfig } from '../config/site';

const HomePage: React.FC = () => {
  return (
    <Layout>
      <SEO
        title={`${siteConfig.brand.name} — Flash USDT software for TRC-20, ERC-20 & BEP-20`}
        description={`${siteConfig.brand.name} is a licensed simulation tool for traders, developers and teams — realistic USDT balances across TRC-20/ERC-20/BEP-20, 50+ wallets, 24/7 WhatsApp support.`}
        keywords="flash USDT software, USDT flashing tool, TRC-20 flash, ERC-20 flash, BEP-20 flash, buy flash USDT, USDT simulation software"
      />
      <NewHero />
      <Audience />
      <HowItWorksNew />
      <WhyChoose />
      <LatestPosts />
      <NewFAQ />
      <CTA />
    </Layout>
  );
};

export default HomePage;
